import { FunctionComponent, useEffect } from "react";
import { Snackbar, SnackbarAction } from "@rmwc/snackbar";
import "@rmwc/snackbar/styles";
import "./NotificationBar.module.scss";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
  selectNotificationStatus,
  hideNotification,
  selectNotificationText,
} from "./notificationBarSlice";

const NotificationBar: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectNotificationStatus);
  const text = useAppSelector(selectNotificationText);

  useEffect(() => {
    setTimeout(() => dispatch(hideNotification()), 2000);
  }, []);

  return (
    <Snackbar
      open={status === 1}
      onClose={() => dispatch(hideNotification())}
      message={text}
      dismissesOnAction
      action={<SnackbarAction label="Close" onClick={() => {}} />}
    />
  );
};

export { NotificationBar, NotificationBar as default };
